/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-20 10:01:57 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 14:07:03
 */

<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Seller FAQ"/>
    <div class="docs">
      <h1>Manage Multiple Sellers</h1>
      <h2>1. How do I manage multiple seller accounts on Artemis Ads?</h2>
      <p>
        You can manage multiple seller accounts in one place by following these
        steps:
      </p>
      <ul>
        <li>
          Go to the left navigation menu and select “Settings - Connections.”
        </li>
        <li>Click the “+ Add Amazon Connection” button.</li>
        <li>
          Log in with your Amazon Seller account credentials in the pop-up
          window.
        </li>
      </ul>
      <p>
        Once connected, all your brands and products will be imported, and you
        can manage them within a single Artemis Ads account.
      </p>
      <h2>
        2. Can I manage multiple brands and products from different seller
        accounts?
      </h2>
      <p>
        Yes! Artemis Ads allows you to connect multiple Amazon Seller accounts
        and manage all your brands and products in one centralized dashboard.
      </p>
      <h2>3. Will Artemis Ads share my account information with Amazon?</h2>
      <p>
        No, Artemis Ads does not share your account information with Amazon.
        Your data is secure and used only to manage your advertising campaigns.
      </p>
      <h2>4. What if I need to disconnect a seller account?</h2>
      <p>
        You can disconnect a seller account at any time by going to “Settings -
        Connections” and removing the desired account. This will not affect your
        Amazon Seller account.
      </p>
      <h2>5. How do I ensure my brands and products are correctly imported?</h2>
      <p>
        After connecting your Amazon Seller account, check the “Brands” and
        “Products” sections in Artemis Ads to ensure everything is imported
        correctly. If you notice any issues, contact support at
        Support@ArtemisAds.com.
      </p>
      <p>Quick Tips for Managing Multiple Sellers</p>
      <ul>
        <li>
          Centralize your accounts: Connect all your Amazon Seller accounts to
          Artemis Ads for seamless management.
        </li>
        <li>
          Check connections regularly: Ensure all accounts are connected and
          functioning properly.
        </li>
        <li>
          Contact support for help: If you encounter any issues, our team is
          here to assist you.
        </li>
      </ul>
      <img
        src="seller/manage-multiple-sellers.png"
        alt="ArtemisAds help center"
      />
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>